<div class="report-modal" [ngClass]="{'darkMode': darkMode}"
  style="width: 100%; min-width: 800px; height: auto;  left: 50% !important; border: solid; text-align: center; display: flex; flex-direction: column;">

  <div class="modal-header d-flex justify-content-center position-relative" [ngClass]="{'darkMode': darkMode}">
    <h3 class="m-0" [ngClass]="{'darkMode': darkMode}">Generate Tonnage Report</h3>

    <button [ngClass]="{'darkMode': darkMode}"
      class="btn position-absolute end-0 me-3"
      (click)="wizardCancelledEmitter.emit()">
      <i class="fas fa-times"></i>
    </button>
  </div>

  <div class="modal-body" style="max-height: 600px; overflow-y: auto; max-width: 95%; padding-left: 5%;" [ngClass]="{'darkMode': darkMode}">
    <mat-accordion class="bubble-accordion" [ngClass]="{'darkMode': darkMode}">
      <mat-expansion-panel [expanded]="true" [ngClass]="{'darkMode': darkMode}">
        <mat-expansion-panel-header [ngClass]="{'darkMode': darkMode}">
          <mat-panel-title [ngClass]="{'darkMode': darkMode}">
            <label [ngClass]="{'darkMode': darkMode}" style="margin-top: 8px;" *ngIf="!isSeasonal">Scale Ticket Date Range: {{!filterDateFrom ? 'All Time' : dateRangeString }}</label>
            <label [ngClass]="{'darkMode': darkMode}" style="margin-top: 8px;" *ngIf="isSeasonal">Report Year:</label>
          </mat-panel-title>
        </mat-expansion-panel-header>
        <div class="row" style="justify-content: center; margin-bottom: 0.5em;" [ngClass]="{'darkMode': darkMode}">
          <div style="min-width: 750px;">
            <div style="display: inline-block;">
              <div class="input-group input-group-sm" style="width: 15em; margin-left: 1em;" *ngIf="!isSeasonal">
                <div class="btn-group" role="group">
                  <input #dateInput
                    [value]="filterDateFrom ? (filterDateFrom | date: 'MM/dd/yyyy') + ' - ' + (filterDateTo | date: 'MM/dd/yyyy') : ''"
                    placeholder="All Time" id="dateRange" name="dateRange" #scaleticketDateRange bsDaterangepicker
                    [bsConfig]="bsConfig" (bsValueChange)="dateRangeChange($event)" style="min-width: 300px;"
                    class="form-control" [ngClass]="{'btn-dark': darkMode, 'darkMode': darkMode}" aria-describedby="cal-addon"
                    matTooltip="Set a scale ticket date range filter" aria-label="Scale Ticket Dash Date Range">
                  <button class="btn" [ngClass]="{'btn-outline-secondary':!darkMode, 'btn-dark': darkMode}"
                    matTooltip="Clear date range" type="button"
                    (click)="filterDateFrom = null; filterDateTo = null; dateRangeChange($event);">
                    <i class="fad fa-calendar fa-lg"></i>
                  </button>
                </div>
              </div>
              <div class="input-group input-group-sm" style="width: 15em; margin-left: 1em;" *ngIf="isSeasonal">
                <input #dateInput autofocus type="number" style="min-width: 300px;" step="1" [value]="year" id="year" name="year"
                  [(ngModel)]="year" (input)="setYear()">
              </div>
              <div class="centerRow" [ngClass]="{'darkMode': darkMode}">
                <div class="buttonRow mt-2">
                  <button *ngFor="let button of summaryReportMonthButtons" [class]="'btn ' + button.class"
                    [ngClass]="{'btn-dark': darkMode}" (click)="button.clickEvent()">
                    {{ button.text }}
                  </button>
                </div>
              </div>

              <div class="centerRow" [ngClass]="{'darkMode': darkMode}">
                <div class="buttonRow mt-2">
                  <button *ngFor="let button of summaryReportYearButtons" [class]="'btn ' + button.class"
                    [ngClass]="{'btn-dark': darkMode}" (click)="button.clickEvent()">
                    {{ button.text }}
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="row" style="justify-content: center; margin-bottom: 0.5em;" [ngClass]="{'darkMode': darkMode}">
          <div style="min-width: 750px; text-align: center;">
            <span style="color: red;" *ngIf="displayDateRangeWarning()">WARNING: This report is better suited to
              shorter
              date ranges. Longer date ranges may cause this report to fail.</span>
          </div>
        </div>
      </mat-expansion-panel>
    </mat-accordion>
  </div>
  <div style="max-height: 600px; overflow-y: auto; max-width: 95%; padding-left: 5%;" [ngClass]="{'darkMode': darkMode}">
    <mat-accordion class="bubble-accordion" [ngClass]="{'darkMode': darkMode}">
      <mat-expansion-panel [ngClass]="{'darkMode': darkMode}">
        <mat-expansion-panel-header [ngClass]="{'darkMode': darkMode}">
          <mat-panel-title [ngClass]="{'darkMode': darkMode}">
            <label style="text-align: end; margin-right: 1em;"
              [matTooltip]="'Leave blank to include ALL Materials'" [ngClass]="{'darkMode': darkMode}">Material(s): {{materialString}}</label>
          </mat-panel-title>
        </mat-expansion-panel-header>

        <div class="row" style="justify-content: center; margin-bottom: 0.5em;" [ngClass]="{'darkMode': darkMode}">
          <div style="min-width: 750px;">
            <div class="card-body" style="padding-top: 0;" [ngClass]="{'darkMode':darkMode}">
              <div class="text-center small alert alert-info mt-0 mb-2" *ngIf="isProcessing">
                <div title="Please wait..." class="ball-pulse">
                  <div></div>
                  <div></div>
                  <div></div>
                </div>
              </div>
              <lib-st-material-select #materialselect *ngIf="!isProcessing" [darkMode]="darkMode"
                [selectedMaterials]="selectedMaterials" [materialSvc]="materialsServices" [selectMode]="true"
                [allMaterials]="allMaterials" (selectionEmitter)="selectMaterial($event)"
                (selectionUpdatedEmitter)="updateMaterials($event)">
                Select Material(s)
              </lib-st-material-select>
            </div>
          </div>
        </div>
      </mat-expansion-panel>
    </mat-accordion>
  </div>
  <div style="max-height: 600px; overflow-y: auto; max-width: 95%; padding-left: 5%;" [ngClass]="{'darkMode': darkMode}">
    <mat-accordion class="bubble-accordion" [ngClass]="{'darkMode': darkMode}">
      <mat-expansion-panel [ngClass]="{'darkMode': darkMode}">
        <mat-expansion-panel-header [ngClass]="{'darkMode': darkMode}">
          <mat-panel-title>
            <label style="text-align: end; margin-right: 1em;" [ngClass]="{'darkMode': darkMode}">
              Customer: {{ !customers || customers.length === 0 ? 'All Customers' : customerString }}
            </label>
          </mat-panel-title>
        </mat-expansion-panel-header>
        <div class="row" style="justify-content: center; margin-bottom: 0.5em;" [ngClass]="{'darkMode': darkMode}">
          <div style="min-width: 750px;">
            <div class="card-body" style="padding-top: 0;" [ngClass]="{'darkMode':darkMode}">
              <div class="text-center small alert alert-info mt-0 mb-2" *ngIf="isProcessing">
                <div title="Please wait..." class="ball-pulse">
                  <div></div>
                  <div></div>
                  <div></div>
                </div>
              </div>
              <lib-customer-select #customerSelect *ngIf="!isProcessing" [darkMode]="darkMode"
                [currentCustomers]="customers" [dateRange]="!showAll ? [filterDateFrom, filterDateTo] : []"
                [stStatus]="filterStatus" [customerSvc]="contactSvc" (selectionEmitter)="selectCustomer($event)">
                Select Customer
              </lib-customer-select>
            </div>
          </div>
        </div>
      </mat-expansion-panel>
    </mat-accordion>
  </div>


  <div class="card-footer" style="padding-left: 0; padding-right: 0;">
    <div class="btn-group d-flex w-100 m-0" style="border-bottom: none;" role="group">
      <button type="button" aria-label="Cancel Selection" class="btn wizardBtn wizardBtn-cancel"
        matTooltip="Cancel Selection" (click)="wizardCancelledEmitter.emit()"
        [matTooltipDisabled]="appGlobals.getTooltipDisplay() !== null ? (!appGlobals.getTooltipDisplay() ? true : false) : false"
        [ngClass]="{'btn-warning': darkMode, 'btn-outline-warning': !darkMode}">
        <i class="fa-lg fa-window-close me-1" [ngClass]="{'fas': darkMode, 'fal': !darkMode}"></i>
        Cancel
      </button>
      <button [disabled]="" type="submit" aria-label="Finish Selection" class="btn wizardBtn wizardBtn-next"
        (click)="generateReport($event)" [ngClass]="{'btn-success': darkMode, 'btn-outline-success': !darkMode}"
        matTooltip="Finish Selection"
        [matTooltipDisabled]="appGlobals.getTooltipDisplay() !== null ? (!appGlobals.getTooltipDisplay() ? true : false) : false">
        <i class="fa-check-square fa-lg ms-1" [ngClass]="{'fas': darkMode, 'fal': !darkMode}"></i>
        Submit
      </button>
    </div>
  </div>

</div>




<!--
<ng-template #step1 let-wrapperForm="wrapperForm">
  <div [ngClass]="{'defaultMode': !darkMode,'darkMode': darkMode}" style="max-height: 600px; overflow-y: auto;">
    <div>

    <!--
    <div>
      <mat-accordion>
        <mat-expansion-panel>
          <mat-expansion-panel-header>
            <mat-panel-title>
              <label style="width: 40%; text-align: end; margin-right: 1em;">Jobs: ({{jobString}})</label>
            </mat-panel-title>
          </mat-expansion-panel-header>
          <div class="row" style="justify-content: center; margin-bottom: 0.5em; min-height: 450px;">
            <div class="scaleTicketRow" style="justify-content: center;" [ngClass]="{'darkMode':darkMode}">
              <h4 class="boxTitle" style="text-align: center;">
                <i class="fal fa-fw fa-address-book"></i> Manage Job Selections
              </h4>
            </div>
            <div class="card-body" style="padding-top: 0;" [ngClass]="{'darkMode':darkMode}">
              <div class="text-center small alert alert-info mt-0 mb-2" *ngIf="isProcessing">
                <div title="Please wait..." class="ball-pulse">
                  <div></div>
                  <div></div>
                  <div></div>
                </div>
              </div>
              <lib-job-select #jobSelect *ngIf="!isProcessing" [darkMode]="darkMode" [currentJobs]="jobs"
                [selectedCustomers]="customers" [customers]="customers" [jobCodes]="jobCodes"
                [jobCategories]="jobCategories" [jobDataSvc]="jobSvc" [sbSvcProvider]="sbSvcProvider"
                [appGlobals]="appGlobals" [reportMode]="true" [sites]="sites" (selectionEmitter)="selectJob($event)">
                Select Jobs for {{reportTitle}}
              </lib-job-select>
            </div>
          </div>
        </mat-expansion-panel>
      </mat-accordion>
    </div>
    -->
    <!--
  </div>
</ng-template>

-->
